import React, { Suspense, lazy } from 'react';
import { inject, observer } from 'mobx-react';

// Dynamically import the templates
// const Template1App = lazy(() => import('./templates/template1/Template1App.js'));
// const Template2App = lazy(() => import('./templates/template2/Template2App.js'));
const Template3App = lazy(() => import('./templates/template3/Template3App.js'));

const App = ({ globalStore1 }) => {
  let TemplateApp;
  switch (globalStore1.count) {
    case 1:
      // TemplateApp = <Template1App translationRef="template1"/>;
      break;
    case 2:
      // TemplateApp = <Template2App translationRef="template2"/>;
      break;
    case 3:
      TemplateApp = <Template3App translationRef="template3"/>;
      break;
    default:
      console.log( 'Unknown Site Version' );
      return <div>Unknown Site Version</div>;
  }

  return (
    // <Suspense fallback={<div>Loading site...</div>}>
    <Suspense fallback={<></>}>
      {TemplateApp}
    </Suspense>
  );
};

export default inject('globalStore1')(observer(App));




// import React from 'react';
// import { inject, observer } from 'mobx-react';
// import Template1App from './templates/template1/Template1App.js';
// import Template2App from './templates/template2/Template2App.js';

// const App = ({test1Store}) => {
//   switch (test1Store.count) {
//     case 1:
//       return <Template1App />;
//       break;
//     case 2:
//       return <Template2App />;
//       break;
//     default:
//       console.log( 'Unknown Site Version' );
//       break;
//   }
// }

// export default inject('test1Store')(observer(App));